
<template>
  <el-card class="notice" v-loading="loading" body-style="height:250px" shadow="never">
    <div class="flex" style="height:24px;line-height:24px;">
      <div class="hd font-lg"><i class="iconfont icon-Fnc text-muted"></i></div>
      <div class="bd ml-sm">
        <span style="font-size:16px;height:24px;line-height:24px">通知</span>
      </div>
      <div class="ft" style="height:24px;line-height:24px">
        <el-link :underline="false" @click="$router.push('/fnc/notice')" style="font-size:14px"
          class="text-muted">更多</el-link>
      </div>
    </div>
    <div class="mt line mb"></div>
    <ul v-for="(item, idx) in list" class="mt" :key="idx">
      <li @click="$router.push('/fnc/notice/detail?id=' + item.id)"><span class="title ellipsis">{{ item.title
      }}</span><span class="text-muted">{{ item.createtime | formatTime('{m}月{d}日') }}</span></li>
    </ul>
  </el-card>
</template>

<script>
import { getNoticeListApi } from "@/api/fnc/fncNoticeApi";
export default {
  data() {
    return {
      loading: false,
      list: [],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      getNoticeListApi(this.listQuery).then((res) => {
        this.loading = false;
        if (!res.errno) {
          if (res.data.list.length >= 4) {
            this.list = res.data.list.splice(0, 4);
          } else {
            this.list = res.data.list;
          }
        }
      });
    },
    onTableRowClick(row) {
      this.$router.push("/fnc/notice/detail?id=" + row.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  height: 1px;
  width: 100%;
  background-color: rgba(238, 240, 245, 1);
}

/deep/ .el-table.notice-table {
  .el-table__row {
    cursor: pointer;
  }

  td {
    border-bottom: none;
    padding: 7px 0;
  }
}

ul {
  margin: 0;
  padding: 0;

  li {
    list-style: none;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .title {
      width: 210px;
    }

    &:hover {
      background-color: rgba(238, 240, 245, 1);
    }
  }
}</style>
